import React, { useEffect, useMemo, useState } from "react";
import "./my-plans.scss";
import TenantPlanDetails from "../../tenant/tenant-details/tenant-details-right-panel/tenant-plan-details/tenant-plan-details";
import { Box } from "@mui/material";
import { BreadcrumbComponent } from "../../../common/components";
import { routes } from "../../../constants/routes";
import { getTenantPlanDetails } from "../../../api/settings";
import { useSetLoading } from "../../../common/hooks/appearance";

const Myplans = () => {
  const [planDetails, setPlanDetails] = useState<any>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const breadcrumbLink = [
    {
      label: "Settings",
      handleClick: () => {},
    },
    {
      label: "My Plans",
      handleClick: () => {},
    },
  ];

  const getDetails = async () => {
    try {
      setIsLoading(true);
      const res = await getTenantPlanDetails();
      const data = res?.data?.data;
      setPlanDetails({
        purchased_subscription_plan: {
          ...data?.activePlanDetails,
          plan_name: data?.activePlanDetails?.planName,
          reports_type: data?.activePlanDetails?.reportsType,
          plan_type: data?.activePlanDetails?.plan_type,
        },
        pendingPlanDetails: data?.pendingPlanDetails,
      });
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
      console.error(e);
    }
  };

  useEffect(() => {
    getDetails();
  }, []);

  const showLoading = useMemo(() => isLoading, [isLoading]);
  useSetLoading(showLoading);
  return (
    <Box>
      <Box>
        <BreadcrumbComponent breadcrumbLink={breadcrumbLink} />
      </Box>
      <Box className="myplans-wrapper">
        <TenantPlanDetails
          tenantData={planDetails}
          path={routes.USER_CHANGE_PLAN}
        />
      </Box>
    </Box>
  );
};

export default Myplans;
